<template>
  <div class="uploadList_cell" v-if="show">
    <ul :style="{ maxHeight: fullScreen ? '400px' : '0px' }">
      <div v-for="(item, index) in list" :key="index">
        <li v-if="item.progress != 100">
          <img
            src="@/assets/common/icon/upload_video_icon.png"
            alt=""
            v-if="item.type == 'video'"
          />
          <img
            src="@/assets/common/icon/upload_img_icon.png"
            alt=""
            v-else-if="item.type == 'image'"
          />
          <img src="@/assets/common/icon/upload_file_icon.png" alt="" v-else />
          <h1 class="title_name">{{ item.name }}</h1>
          <p class="progress">{{ item.size | filterType }}</p>
          <p class="progress" style="flex: 1">{{ item.progress }}%</p>
          <!-- <i
            class="icon-bofang5 iconfont"
            @click="handleItem('pause', item)"
            v-if="pause_uid.includes(item.uid)"
          ></i>
          <i
            class="icon-stop iconfont"
            @click="handleItem('start', item)"
            v-else
          ></i> -->
          <!-- <i class="el-icon-close" @click="handleItem('remove', item)"></i> -->
          <div class="bgcolor" :style="{ width: `${item.progress}%` }"></div>
        </li>
      </div>
    </ul>

    <div class="cell_manage">
      <div class="manage_left">
        <p>进行中</p>
        <span>{{ number }}</span>
        <p style="margin-left: 10px">已完成</p>
        <span>{{ list.length - number }}</span>
      </div>
      <div class="manage_right">
        <i
          class="icon-suoxiao iconfont"
          v-if="fullScreen"
          @click="handle('size')"
        ></i>
        <i class="icon-quanping iconfont" v-else @click="handle('size')"></i>
        <i class="icon-guanbi1 iconfont" @click="handle('close')"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DownLoadList",
  components: {},
  props: {
    list: {
      type: Array,
    },
    number: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      show: false,
      fullScreen: true,
      pause_uid: [],
    };
  },
  methods: {
    open() {
      this.show = true;
    },
    close() {
      this.show = false;
    },
    handleItem(type, item) {
      if (type == "pause") {
        this.pause_uid.push(item.uid);
      } else if (type == "start") {
        this.pause_uid = this.pause_uid.filter((v) => v != item.uid);
      }
      // this.$emit("handleItem", { type, uid: item.uid });
    },
    handle(type) {
      if (type == "close") {
        this.close();
      } else {
        this.fullScreen = !this.fullScreen;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.uploadList_cell {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  box-shadow: 0 0px 5px 0px rgba(0, 0, 0, 0.2);
  ul {
    width: 100%;
    transition: 0.3s;
    overflow: auto;
    li {
      width: 100%;
      display: flex;
      align-items: center;
      padding: 10px;
      position: relative;
      border-bottom: 1px solid #f5f5f5;
      .bgcolor {
        height: 100%;
        background-color: rgba(47, 117, 251, 0.1);
        position: absolute;
        left: 0;
        top: 0;
        z-index: -1;
      }
      .iconfont {
        font-size: 16px;
      }
      .el-icon-close {
        font-size: 18px;
        margin-left: 14px;
      }
      img {
        width: 40px;
        height: 40px;
      }
      .title_name {
        font-size: 16px;
        color: #000;
        padding-left: 10px;
        width: 240px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-weight: 500;
      }
      .progress {
        font-size: 16px;
        color: #666;
        padding: 0 10px;
      }
    }
  }
  .cell_manage {
    width: 100%;
    height: 50px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 2px solid rgba(0, 0, 0, 0.2);
    .manage_left {
      display: flex;
      align-items: center;
      p {
        font-size: 12px;
      }
      span {
        font-size: 12px;
        color: #666;
        padding: 0 6px;
      }
    }
    .manage_right {
      .iconfont {
        font-size: 16px;
        margin-left: 10px;
      }
    }
  }
}
</style>
